import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: any) => {
  return {
    container: {
      flexDirection: 'column',
      display: 'flex',
      '& fieldset': {
        border: '1px solid #000000 !important',
      },
      '& div': {
        backgroundColor: 'transparent  !important',
        zIndex: 7,
      },
      '&>div': {
        borderRadius: '20px',
        padding: '0px 8px',
      },
      position: 'relative',
      justifyContent: 'center',
      // width: "150px"
    },
    container2: {
      flexDirection: 'column',
      display: 'flex',
      '& fieldset': {
        border: '1px solid #000000 !important',
      },
      '& div': {
        backgroundColor: 'transparent  !important',
        zIndex: 7,
      },
      '&>div': {
        borderRadius: '20px',
        padding: '0px 0px',
      },
      position: 'relative',
      justifyContent: 'center',
      width: "120px"
    },
    containerErr: {},
    rowLabel:{
      display: 'flex',
      alignItems: 'center',
      '& img': {
        opacity: '1 !important',
      }
    },
    label: {
      font: theme.custom.font.label,
      marginRight: 9,
      color: theme.custom.colors.primary,
    },
    rootDropdown: {
      height: '32px',
      alignItems: 'center',
      display: 'flex',
      borderRadius: '20px',
      padding: '0px 0px 0px 8px !important',
    },
    iconDropdown: {
      position: 'absolute',
      right: '9px',
      width: "15px",
      height: "15px",
      transition: 'all 0.35s 0.15s',
    },
    iconUp: {
      transform: 'rotate(180deg)',
    },
    iconDown: {
      transform: 'rotate(360deg)',
    },
    paper: {
      marginTop: '-3px',
      '& ul': {
        padding: 0,
      }
    },
    placeholder: {
      font: theme.custom.font.text12,
      color: theme.custom.colors.midBlack,
    },
    menuItem: {
      font: 'normal normal 400 12px/16px Public-Sans',
      color: theme.custom.colors.midBlack,
    },
    menuItem2: {
      font: 'normal normal 400 12px/16px Public-Sans',
      color: theme.custom.colors.midBlack,
      position: 'absolute',
      marginLeft: 10,
      zIndex: 30,
    },
    tooltip: {
      background: '#333',
      padding: 9,
      font: 'normal normal 400 13px/24px Public-Sans',
    },
    popupTooltip: {
      color: '#111',
    },
    disable: {
      '& div:nth-child(2)': {
        '& *': { cursor: 'not-allowed' },
      },
      '& fieldset': {
        border: '1px solid #D2D2D2 !important',
      },
      '& img': {
        opacity: 0.1,
      },
    },
  };
});

export default useStyles;
